import { useCallback, useEffect, useState } from 'react';
import apiClient from 'services/apiClient';

export const useInternationalGateway = ({ api, authToken, userId }) => {
    const [gatewayEnabled, setGatewayEnabled] = useState(false);
    const [loading, setLoading] = useState(true);

    const fetchGateway = useCallback(async () => {
        if (!userId) {
            setGatewayEnabled(false);
            setLoading(false);
            return;
        }

        setLoading(true);
        try {
            const response = await apiClient.get(`${api}user-pricing/${userId}/controls`, {
                headers: { Authorization: `Bearer ${authToken}` },
            });
            setGatewayEnabled(response?.data?.data?.international_gateway_enabled === true);
        } catch (error) {
            setGatewayEnabled(false);
        } finally {
            setLoading(false);
        }
    }, [api, authToken, userId]);

    useEffect(() => {
        fetchGateway();
    }, [fetchGateway]);

    return { gatewayEnabled, gatewayLoading: loading, refreshGateway: fetchGateway };
};

export default useInternationalGateway;
